if (!customElements.get('addon-products')) {
  class AddonProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.getAttribute('data-product-id');
      this.products = [];
      if (window.addonProducts && window.addonProducts[this.productId]) {
        this.products = window.addonProducts[this.productId];
      }
      // console.log(this.products);
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('.addon-item').forEach((item) => {
        item.addEventListener('click', (evt) => {
          evt.preventDefault();
          item.classList.toggle('selected');
          this.calculateTotal();
        });
      });
      document.addEventListener('on:variant:change', (event) => {
        if (event.detail.product && event.detail.variant) {
          let productId = event.detail.product.id;
          if (window.addonProducts && window.addonProducts[productId]) {
            window.addonMainVariants[productId] = event.detail.variant;
            this.calculateTotal();
          }
        }
      });
    }

    calculateTotal() {
      const selectedItems = this.querySelectorAll('.addon-item.selected');
      if (!selectedItems.length) {
        this.querySelector('.addon-total')?.classList.add('hidden');
        return;
      }
      let subtotal = 0;
      let total = 0;
      let subtotalBeforeSale = 0;
      let totalBeforeSale = 0;
      let discount = 0;
      let vatRate = this.getAttribute('data-vat-rate') || 1;
      selectedItems.forEach((item) => {
        let variantId = item.getAttribute('data-variant-id');
        let variant = this.products.find((product) => {
          return product.variants.find((v) => v.id == variantId);
        });
        if (variant) {
          subtotal += variant.price;
          subtotalBeforeSale += variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        }
      });
      if (document.body.getAttribute('data-show-vat') == 'true') {
        subtotal = subtotal * vatRate;
        subtotalBeforeSale = subtotalBeforeSale * vatRate;
      }
      discount = subtotalBeforeSale - subtotal;
      // this.querySelector('.addon-subtotal-price-amount').textContent = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (parseFloat(subtotal)/100).toFixed(2));
      this.querySelector('.addon-subtotal-price-amount').textContent = this.formatMoney(parseFloat(subtotal), theme.settings.moneyWithCurrencyFormat);
      if (discount > 0) {
        // this.querySelector('.addon-total-save-amount').textContent = this.formatMoney(parseFloat(discount), theme.settings.moneyWithCurrencyFormat);
        // this.querySelector('.addon-total-save').classList.remove('hidden');

        this.querySelector('.addon-subtotal-old-price-amount').textContent = this.formatMoney(parseFloat(subtotalBeforeSale), theme.settings.moneyWithCurrencyFormat);
        this.querySelector('.addon-subtotal-old-price-amount').classList.remove('hidden');
      } else {
        // this.querySelector('.addon-total-save').classList.add('hidden');
        this.querySelector('.addon-subtotal-old-price-amount').classList.add('hidden');
      }
      if (window.addonMainVariants && window.addonMainVariants[this.productId]) {
        let mainVariantPrice = window.addonMainVariants[this.productId].price;
        let mainVariantCompareAtPrice = window.addonMainVariants[this.productId].compare_at_price;
        if (document.body.getAttribute('data-show-vat') == 'true') {
          mainVariantPrice = mainVariantPrice * vatRate;
          mainVariantCompareAtPrice = mainVariantCompareAtPrice * vatRate;
        }
        total = subtotal + mainVariantPrice;
        if (mainVariantCompareAtPrice && mainVariantCompareAtPrice > mainVariantPrice) {
          totalBeforeSale = subtotalBeforeSale + mainVariantCompareAtPrice;
        } else {
          totalBeforeSale = subtotalBeforeSale + mainVariantPrice;
        }
        this.querySelector('.addon-total-price-amount').textContent = this.formatMoney(parseFloat(total), theme.settings.moneyWithCurrencyFormat);
        if (totalBeforeSale > total) {
          this.querySelector('.addon-total-old-price-amount').textContent = this.formatMoney(parseFloat(totalBeforeSale), theme.settings.moneyWithCurrencyFormat);
          this.querySelector('.addon-total-old-price-amount').classList.remove('hidden');
        }
      }
      this.querySelector('.addon-total')?.classList.remove('hidden');
    }

    formatMoney(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || this.money_format);
    
      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }
    
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
    
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      }
    
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    
      return formatString.replace(placeholderRegex, value);
    };    
  }

  customElements.define('addon-products', AddonProducts);
}
